import { useEffect, useRef, useState } from "react";

export function useInView(options = { threshold: 0.15, once: true }) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return undefined;
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          if (options.once) io.disconnect();
        } else if (!options.once) {
          setInView(false);
        }
      },
      { threshold: options.threshold }
    );
    io.observe(node);
    return () => io.disconnect();
  }, [options.threshold, options.once]);

  return [ref, inView];
}

export function Reveal({ children, delay = 0, as: Tag = "div", className = "", ...rest }) {
  const [ref, inView] = useInView({ threshold: 0.18, once: true });
  return (
    <Tag
      ref={ref}
      style={{ transitionDelay: `${delay}ms` }}
      className={`reveal ${inView ? "in-view" : ""} ${className}`}
      {...rest}
    >
      {children}
    </Tag>
  );
}
